import Chart from 'react-apexcharts';
import useBarChartConfig from './config';

type Props = {
  seriesData: number[],
}

export default function BarChart({ seriesData }: Props):JSX.Element {
  const chartOptions = useBarChartConfig();

  const chartSeries = [{ data: seriesData }];

  return (
    <Chart
      options={ chartOptions }
      series={ chartSeries }
      type="bar"
      width={ 120 }
    />
  );
}
